<div class="info">
  <div class="info-wrapper">
    @for (link of headerLinks; track $index) {
      @let sameSiteLink = sameSite(link);
      @if (sameSiteLink) {
        <a class="nav" [routerLink]="sameSiteLink.targetUrl" [target]="sameSiteLink.new ? '_blank' : '_self'">
          {{ sameSiteLink.titleText }}
        </a>
      }
      @if (!sameSiteLink) {
        <a class="nav" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'">{{ link.titleText }}</a>
      }
    }
    @if (enableMembers) {
      <app-member-bar></app-member-bar>
    }
  </div>
</div>
<div class="spacer">
  @if (!logoLink) {
    <a routerLink="/" class="logo-container">
      <img [src]="storeLogo.src | cms: 50" [alt]="storeLogo.alt" />
    </a>
  }
  @if (logoLink) {
    <a [href]="logoLink" class="logo-container">
      <img [src]="storeLogo.src | cms: 50" [alt]="storeLogo.alt" />
    </a>
  }
  <div class="links">
    @for (link of links; track $index) {
      @if (link.type === 'link') {
        @let sameSiteLink = sameSite(link);
        @if (sameSiteLink) {
          <a class="nav" [routerLink]="sameSiteLink.targetUrl" [target]="sameSiteLink.new ? '_blank' : '_self'">
            {{ sameSiteLink.titleText }}
          </a>
        }
        @if (!sameSiteLink) {
          <a class="nav" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'">{{ link.titleText }}</a>
        }
      }

      @if (link.type === 'subNav') {
        <div class="sub-nav">
          <a
            [class.no-pointer]="!link.link"
            [class.open]="openNavigationName === link.title"
            class="nav"
            (mouseenter)="openNavigation(navContent, link.title)"
            (focus)="openNavigation(navContent, link.title)"
            [routerLink]="link.link ? [link.link] : []"
            (click)="link.link && closeNavigation()"
            [target]="link.linkTarget"
            tabindex="0"
          >
            {{ link.title }}
          </a>
          <div class="sub-nav-content" [class.display]="openNavigationName === link.title" tabindex="-1" #navContent>
            <div>
              @for (link of link.pages; track $index) {
                @let sameSiteLink = sameSite(link);
                @if (sameSiteLink) {
                  <a
                    class="nav small"
                    [routerLink]="sameSiteLink.targetUrl"
                    [target]="sameSiteLink.new ? '_blank' : '_self'"
                    (click)="closeNavigation()"
                  >
                    {{ sameSiteLink.titleText }}
                  </a>
                }
                @if (!sameSiteLink) {
                  <a class="nav small" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'" (click)="closeNavigation()">
                    {{ link.titleText }}
                  </a>
                }
              }
            </div>
          </div>
        </div>
      }

      @if (link.type === 'burger') {
        <div class="burger-nav">
          <a
            [class.no-pointer]="!link.link"
            [class.open]="openNavigationName === link.title"
            class="nav"
            (mouseenter)="openNavigation(navContent, link.title)"
            (focus)="openNavigation(navContent, link.title)"
            [routerLink]="link.link ? [link.link] : []"
            (click)="link.link && closeNavigation()"
            [target]="link.linkTarget"
            tabindex="0"
          >
            {{ link.title }}
          </a>
          <div class="burger-nav-content" [class.display]="openNavigationName === link.title" tabindex="-1" #navContent>
            <div>
              @for (link of link.pages; track $index) {
                @let sameSiteLink = sameSite(link);
                @if (sameSiteLink) {
                  <a
                    class="nav"
                    [routerLink]="sameSiteLink.targetUrl"
                    [target]="sameSiteLink.new ? '_blank' : '_self'"
                    (click)="closeNavigation()"
                  >
                    {{ sameSiteLink.titleText }}
                  </a>
                }
                @if (!sameSiteLink) {
                  <a class="nav" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'" (click)="closeNavigation()">
                    {{ link.titleText }}
                  </a>
                }
              }
            </div>
          </div>
        </div>
      }

      @if (link.type === 'categoryBurger') {
        <div class="burger-nav">
          <a
            [class.no-pointer]="!link.link"
            [class.open]="openNavigationName === link.title"
            class="nav"
            (mouseenter)="openNavigation(navContent, link.title)"
            (focus)="openNavigation(navContent, link.title)"
            [routerLink]="link.link ? [link.link] : []"
            (click)="link.link && closeNavigation()"
            [target]="link.linkTarget"
            tabindex="0"
          >
            {{ link.title }}
          </a>
          <div class="burger-nav-content" [class.display]="openNavigationName === link.title" tabindex="-1" #navContent>
            <div>
              @for (link of link.pages; track $index) {
                @let sameSiteLink = sameSite(link);
                @if (sameSiteLink) {
                  <a
                    class="nav"
                    [routerLink]="sameSiteLink.targetUrl"
                    [target]="sameSiteLink.new ? '_blank' : '_self'"
                    (click)="closeNavigation()"
                  >
                    {{ sameSiteLink.titleText }}
                  </a>
                }
                @if (!sameSiteLink) {
                  <a class="nav" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'" (click)="closeNavigation()">
                    {{ link.titleText }}
                  </a>
                }
              }
            </div>
          </div>
        </div>
      }
    }

    @if (!hideGroceries && !showOnlyLogo) {
      @if (!groceries.button) {
        <a class="nav products" [routerLink]="groceries.url">{{ groceries.name }}</a>
      } @else {
        <app-text-button class="nav" [routerLink]="groceries.url">
          {{ groceries.name }}
        </app-text-button>
      }
    }
  </div>
  @if (!showOnlyLogo) {
    <div class="shipping-basket-wrapper">
      @if (showShipping && !(!isMobile && storeClosed)) {
        <div class="shipping">
          <app-icon-button [icon]="menuIcon" id="menu" (click)="openMenu()" [border]="false"></app-icon-button>
          <label for="menu" (click)="openMenu()">{{ menuLabel }}</label>
        </div>
      }

      @if (showBasket) {
        <div class="basket">
          <app-icon-button [icon]="basketIcon" (click)="openBasket()" [border]="false" [matBadge]="count$ | async"></app-icon-button>
        </div>
      }
    </div>
  }
</div>
